// Mobile Bridge related constants

export const MOBILE_BRIDGE_EVENT_SEND = {
  CHANGE_THEME: 'CHANGE_THEME',
  // ENABLE_BIOMETRIC: 'ENABLE_BIOMETRIC',
  GET_FCM_TOKEN: 'GET_FCM_TOKEN',
  // USER_LOGGED_IN: 'USER_LOGGED_IN',
  NATIVE_SHARE: 'NATIVE_SHARE',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  REMOVE_AUTH_TOKEN: 'REMOVE_AUTH_TOKEN',
  SET_ORIGIN: 'SET_ORIGIN',
  GET_LOCATION: 'GET_LOCATION',
  SET_DOWNLOAD_URL: 'SET_DOWNLOAD_URL',
  NATIVE_IMAGE_PICKER: 'NATIVE_IMAGE_PICKER',
  NATIVE_VIDEO_PICKER: 'NATIVE_VIDEO_PICKER',
  INITIATE_PAYMENT: 'INITIATE_PAYMENT',
  REELS_MOBILE_FEED: 'REELS_MOBILE_FEED',
  RELOADED: 'RELOADED',
  SHOW_LAUNCH: 'SHOW_LAUNCH',
  IMAGE_VIDEO_PICKER: 'IMAGE_VIDEO_PICKER',
  ALL_MEDIA_PICKER: 'ALL_MEDIA_PICKER',
  USE_IN_APP_PURCHASE: 'USE_IN_APP_PURCHASE'
};

export const MOBILE_BRIDGE_EVENT_RECEIVE = {
  DEFAULT_DEVICE_THEME: 'DEFAULT_DEVICE_THEME',
  DEVICE_TYPE: 'DEVICE_TYPE',
  // LOGOUT_USER: 'LOGOUT_USER',
  DEVICE_NOTIFICATION_TOKEN: 'DEVICE_NOTIFICATION_TOKEN',
  REDIRECT_TO: 'REDIRECT_TO',
  SET_LOCATION: 'SET_LOCATION',
  SET_TOP_PADDING: 'SET_TOP_PADDING',
  SET_IMAGE_UPLOAD: 'SET_IMAGE_UPLOAD',
  SET_VIDEO_UPLOAD: 'SET_VIDEO_UPLOAD',
  PAYMENT_DETAILS: 'PAYMENT_DETAILS',
  PERMISSIONS: 'PERMISSIONS',
  SET_IMAGE_VIDEO_PICKER: 'SET_IMAGE_VIDEO_PICKER',
  SET_ALL_MEDIA_PICKER: 'SET_ALL_MEDIA_PICKER',
  UPDATE_USER_WALLET: "UPDATE_USER_WALLET",
  CLEAR_CACHE_AND_HARD_RELOAD: 'CLEAR_CACHE_AND_HARD_RELOAD'
};

export const REELS_SOURCES = {
  PROFILE_FILTER: 'PROFILE_FILTER',
  PROFILE_FEED: 'PROFILE_FEED',
  FOLLOW: 'FOLLOW',
  DISCOVER: 'DISCOVER',
  SAVED: 'SAVED',
  ACTIVITY: 'ACTIVITY',
  HASHTAG: 'HASHTAG',
  TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
  MY_PURCHASES: 'MY_PURCHASES',
}

export const MOBILE_BRIDGE_CHANNEL = 'ReactNativeWebView';

export const MESSAGE = 'message';

export interface imagePickerProps {
  isMultiple: boolean;
  cropperOptions?: any;
  messageType?: string;
}